import { useContext } from 'react';
import { createContext } from 'react';

import { NewsletterFormProps } from '../@types/NewsletterFormProps';

export const NewsletterFormContext = createContext<NewsletterFormProps>({} as NewsletterFormProps);

NewsletterFormContext.displayName = 'NewsletterForm';

const NewsletterFormProvider = (props: NewsletterFormProps) => {
	return <NewsletterFormContext.Provider value={props}>{props.children}</NewsletterFormContext.Provider>;
};

export const useNewsletterForm = () => {
	const context = useContext(NewsletterFormContext);

	return context;
};

export default NewsletterFormProvider;
